import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { filter, firstValueFrom } from 'rxjs';

import { CommunityProfileType, Room } from '@models';
import { RoomService, ToastService, UserBeanService } from '@services';
import { AppState } from '@store';
import { opensRoomsInsteadOfHome } from 'src/app/core/guards/community-profile.guard';

export const roomsResolver: ResolveFn<Room> = async ({ queryParams }) => {
  const userBeanService = inject(UserBeanService);
  const roomService = inject(RoomService);
  const store: Store<AppState> = inject(Store);
  const router = inject(Router);
  const toastService = inject(ToastService);
  const translate = inject(TranslateService);

  const userBean = await userBeanService.getUserBean();

  await firstValueFrom(
    store
      .select((state) => state.auth.isLoggedIn)
      .pipe(filter((isLoggedIn) => isLoggedIn))
  );

  if (userBean.communityProfileId === CommunityProfileType.SIGNING_ROOM) {
    return new RedirectCommand(
      router.createUrlTree(['/home'], { queryParams })
    );
  }

  if (userBean.rootRoomsPermission < 1) {
    return new RedirectCommand(
      router.createUrlTree(['/shared-with-me'], { queryParams })
    );
  }

  try {
    return await firstValueFrom(roomService.getRoomProperties());
  } catch (error) {
    if (opensRoomsInsteadOfHome(userBean)) {
      toastService.show({
        text: translate.instant('WEB_NOTIFY_LOAD_FAILED'),
        type: 'danger',
      });

      throw error;
    }

    return new RedirectCommand(router.parseUrl('/home'));
  }
};
